import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import LinkWithLocale from '@/components/LinkWithLocale/LinkWithLocale';
import { Typography } from '@/components/Typography';
import { px2rem } from '@/theme';

import { ReactComponent as CloseSvg } from '@/assets/close-big-light.svg';

export const Wrapper = styled(Box)<{ isOpen: boolean; offset: number }>`
  position: fixed;
  width: 100%;
  height: 100%;
  top: ${px2rem(-500)};
  left: 0;
  opacity: 0;
  visibility: hidden;
  overflow: scroll;

  ${({ offset }) => css`
    padding-top: ${px2rem(offset)};
  `}

  ${({ theme }) => css`
    background: ${theme.colors.white};
    z-index: ${theme.zIndex.searchOverlay};
    transition: ${theme.transitions.create(['top', 'opacity', 'visibility'])};
  `}
  ${({ isOpen }) =>
    isOpen &&
    css`
      opacity: 1;
      visibility: visible;
      top: 0;
    `};
`;

export const Content = styled(Box)`
  width: 100%;
  text-align: center;

  ${({ theme }) => css`
    background: ${theme.colors.white};
    font-family: ${theme.fontFamilies.italianPlate};
    padding: ${theme.spacing(3)};
  `}
`;

export const SuggestedSearchText = styled(Typography)`
  width: fit-content;
  text-transform: uppercase;
  font-family: inherit;

  ${({ theme }) => css`
    font-size: ${theme.fontSizes.h5};
    margin: ${theme.spacing(1)} auto 0 auto;
  `}
`;

export const StyledLink = styled(LinkWithLocale)`
  text-decoration: none;
  color: inherit;
  ${({ theme }) => theme.transitions.create('color')}

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
`;

export const SearchSection = styled(Box)`
  margin: 0 auto;
  max-width: ${({ theme }) =>
    theme.components.searchOverlay.searchSection.width};
`;

export const CloseIcon = styled(CloseSvg)<{ offset: number }>`
  width: ${px2rem(24)};
  position: absolute;
  right: 24px;
  top: 70px;
  ${({ offset }) => css`
    top: ${px2rem(offset)};
  `}
  cursor: pointer;
  color: ${({ theme }) => theme.colors.secondaryGrey};
`;

export const RetailersWrapper = styled(Flex)`
  justify-content: end;
  align-items: center;

  ${({ theme }) => css`
    font-size: ${theme.fontSizes.p1};
    margin: ${theme.spacing(1)} auto;

    a {
      padding-top: ${theme.space.s025};
    }
    svg,
    a {
      color: ${theme.colors.primaryDark};
    }

    &:hover {
      cursor: pointer;

      svg,
      a {
        transition: ${theme.transitions.create('color')};
        color: ${theme.colors.primary};
      }
    }
  `}
`;
